// Isotipo OpenBackup — SVG inline.
//
// Va inline en el bundle (no es un upload ni un archivo servido desde
// /uploads/branding), asi que no toca la prohibicion de SVG subidos por
// usuario. Tiene que ser inline y no <img src="...svg"> porque un SVG
// externo es un documento aparte y no hereda las variables CSS del tema.
//
//   size      alto en px (el ancho sale del aspecto 1.37:1)
//   title     si se pasa, el SVG se anuncia con ese nombre accesible.
//             Si el isotipo va al lado del wordmark en texto, dejalo
//             vacio: el lector de pantalla ya lee el texto y anunciarlo
//             dos veces molesta.

export default function CloudMark({ size = 32, title = '', ...rest }) {
  const a11y = title
    ? { role: 'img', 'aria-label': title }
    : { 'aria-hidden': 'true', focusable: 'false' };

  return (
    <svg
      viewBox="0 0 131.5 96"
      height={size}
      width={(size * 131.5) / 96}
      xmlns="http://www.w3.org/2000/svg"
      {...a11y}
      {...rest}
    >
      <g fill="var(--brand-cloud, #206FB2)">
        <circle cx="66.21" cy="39.72" r="39.72" />
        <circle cx="102.22" cy="57.69" r="29.24" />
        <circle cx="28.03" cy="58.47" r="25" />
        <rect x="0" y="52.79" width="126.46" height="43.21" rx="20.63" />
      </g>
      {/* Arco abierto a las 3 en punto + punta de flecha */}
      <path
        d="M82.45 52.77 A16.43 16.43 0 1 1 79.68 46.04"
        fill="none"
        stroke="var(--brand-cloud-mark, #FFFFFF)"
        strokeWidth="3.91"
      />
      <path
        d="M76.17 32.69 L81.34 44.74 L68.5 47.61 Z"
        fill="var(--brand-cloud-mark, #FFFFFF)"
      />
    </svg>
  );
}
